/* VIBECRAFTS Watermark Protection — v2 (No Blink)
   - Original image kabhi DOM me move nahi hoti => koi blink nahi
   - Ek hi invisible cover poori site ke liye, right-click ke waqt image ke upar aata hai
   - Watermark blob cache hota hai => dusri baar instant
*/
(function () {
  'use strict';

  var WM_TEXT = 'VIBECRAFTS';

  var blobCache = {};   // src -> watermarked blob URL
  var pending   = {};   // src -> generation in progress
  var cover     = null; // single reusable overlay <img>
  var coverSrc  = '';   // kis image src ke liye cover abhi dikh raha hai

  /* ---------- Watermark generation (on-demand, cached) ---------- */

  function generate(src, cb) {
    if (blobCache[src]) { cb(blobCache[src]); return; }
    if (pending[src])   { cb(null); return; }
    pending[src] = true;

    var temp = new Image();
    temp.crossOrigin = 'anonymous';

    temp.onload = function () {
      var w = temp.naturalWidth, h = temp.naturalHeight;
      if (!w || !h) { pending[src] = false; cb(null); return; }

      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var ctx = c.getContext('2d');

      try { ctx.drawImage(temp, 0, 0, w, h); }
      catch (e) { pending[src] = false; cb(null); return; }

      ctx.translate(w / 2, h / 2);
      ctx.rotate(-Math.atan2(h, w));
      ctx.font = 'bold ' + Math.floor(w / 7) + 'px Arial';
      ctx.fillStyle = 'rgba(128,128,128,0.45)';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(WM_TEXT, 0, 0);

      c.toBlob(function (blob) {
        pending[src] = false;
        if (!blob) { cb(null); return; }
        blobCache[src] = URL.createObjectURL(blob);
        cb(blobCache[src]);
      }, 'image/png', 0.95);
    };

    temp.onerror = function () { pending[src] = false; cb(null); };
    temp.src = src;
  }

  /* ---------- Single global cover overlay ---------- */

  function ensureCover() {
    if (cover) return cover;
    cover = document.createElement('img');
    cover.alt = '';
    cover.draggable = true;
    cover.style.cssText =
      'position:fixed;display:none;margin:0;padding:0;border:0;' +
      'opacity:0;z-index:2147483647;pointer-events:auto;';
    document.body.appendChild(cover);
    return cover;
  }

  function hideCover() {
    if (cover && cover.style.display !== 'none') {
      cover.style.display = 'none';
      coverSrc = '';
    }
  }

  // Cover ko image ke exact upar rakho. true = ready (watermark laga hua)
  function showCover(img) {
    var src = img.currentSrc || img.src;
    if (!src) return false;

    var c = ensureCover();
    var url = blobCache[src];

    if (!url) {
      // Background me bana lo — agli baar instant milega
      generate(src, function (u) {
        if (u && coverSrc === src && c.style.display !== 'none') c.src = u;
      });
      return false;
    }

    var r = img.getBoundingClientRect();
    c.src = url;
    c.style.left   = r.left + 'px';
    c.style.top    = r.top + 'px';
    c.style.width  = r.width + 'px';
    c.style.height = r.height + 'px';
    c.style.display = 'block';
    coverSrc = src;
    return true;
  }

  /* ---------- Event target se image nikalo ---------- */

  function targetImage(e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || t === cover) return null;
    if (t.tagName === 'IMG') return t;
    var inner = t.querySelector && t.querySelector('img');
    return inner || null;
  }

  /* ---------- Delegated listeners (poori site ke liye) ---------- */

  // Right-click: mousedown pe hi cover laga do (contextmenu se pehle)
  document.addEventListener('mousedown', function (e) {
    if (e.button === 2) {
      var img = targetImage(e);
      if (img) showCover(img);
      return;
    }
    // Left click: cover pe hua to hatao aur neeche wale element pe click pass karo
    if (e.button === 0 && cover && e.target === cover) {
      var x = e.clientX, y = e.clientY;
      hideCover();
      e.preventDefault();
      e.stopPropagation();
      var el = document.elementFromPoint(x, y);
      if (el) el.click();
      return;
    }
    if (e.button === 0) hideCover();
  }, true);

  document.addEventListener('contextmenu', function (e) {
    // Cover pe right-click => menu khulne do (Save karega to watermark milega)
    if (e.target === cover) return;

    var img = targetImage(e);
    if (!img) { hideCover(); return; }

    var ready = showCover(img);
    // Watermark abhi ready nahi => menu mat khulne do (original save na ho)
    e.preventDefault();
    if (ready) {
      // Cover lag chuka hai, turant usi jagah dobara contextmenu bhejo
      var ev = new MouseEvent('contextmenu', {
        bubbles: true, cancelable: true,
        clientX: e.clientX, clientY: e.clientY, button: 2
      });
      cover.dispatchEvent(ev);
    }
  }, true);

  // Drag: original image kabhi drag na ho; cover drag hua to watermarked jayega
  document.addEventListener('dragstart', function (e) {
    if (e.target === cover) return; // watermarked drag allowed
    var img = targetImage(e);
    if (!img) return;
    e.preventDefault();
    var src = img.currentSrc || img.src;
    if (src) generate(src, function () {});
  }, true);

  // Mobile long-press (save image dialog)
  var touchTimer = null;
  document.addEventListener('touchstart', function (e) {
    if (e.target === cover) return;
    var img = targetImage(e);
    if (!img) { hideCover(); return; }
    var src = img.currentSrc || img.src;
    if (src && !blobCache[src]) generate(src, function () {});
    touchTimer = setTimeout(function () { showCover(img); }, 300);
  }, { capture: true, passive: true });

  document.addEventListener('touchmove', function () {
    clearTimeout(touchTimer);
    hideCover();
  }, { capture: true, passive: true });

  document.addEventListener('touchend', function () {
    clearTimeout(touchTimer);
  }, { capture: true, passive: true });

  // Scroll/resize pe cover position galat ho jayegi => hata do
  window.addEventListener('scroll', hideCover, { capture: true, passive: true });
  window.addEventListener('resize', hideCover, { passive: true });

})();